import { Modal } from 'components/UI/Modal'
import FbButton from 'components/FbUI/FbButton'
import { MdClose } from 'react-icons/md'
import styled from 'styled-components/macro'

interface SyndigoSyncModalProps {
  show: boolean
  variantName: string
  isLoading: boolean
  onConfirm: () => void
  onCancel: () => void
}

export function SyndigoSyncModal({
  show,
  variantName,
  isLoading,
  onConfirm,
  onCancel,
}: SyndigoSyncModalProps) {
  return (
    <Modal
      centered
      onHide={onCancel}
      backdrop={isLoading ? 'static' : true}
      show={show}
    >
      <Modal.Header className="flex justify-content-between align-items-center">
        <Modal.Title>Resync Variant</Modal.Title>
        {!isLoading && <CloseIcon className="text-muted" onClick={onCancel} />}
      </Modal.Header>
      <Modal.Body>
        <span>
          Are you sure you want to resync the variant &quot;{variantName}
          &quot;?
        </span>
      </Modal.Body>
      <Modal.Footer className="d-flex">
        <FbButton
          style={{ flex: 1 }}
          variant="secondary"
          onClick={onCancel}
          disabled={isLoading}
        >
          Cancel
        </FbButton>
        <FbButton
          variant="primary"
          style={{ flex: 1 }}
          onClick={onConfirm}
          disabled={isLoading}
          loading={isLoading}
        >
          {isLoading ? 'Syncing...' : 'Confirm'}
        </FbButton>
      </Modal.Footer>
    </Modal>
  )
}

const CloseIcon = styled(MdClose)`
  color: #aaa;
  font-size: 20px;
  cursor: pointer;
  transition: all 0.14s ease-in-out;

  &:hover {
    color: #444 !important;
  }

  &:focus {
    color: #000 !important;
  }

  &:active {
    color: #000 !important;
  }
`
